import { render, staticRenderFns } from "./printSettlementBill.vue?vue&type=template&id=35ffd0d8&scoped=true"
import script from "./printSettlementBill.vue?vue&type=script&lang=js"
export * from "./printSettlementBill.vue?vue&type=script&lang=js"
import style0 from "./printSettlementBill.vue?vue&type=style&index=0&id=35ffd0d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ffd0d8",
  null
  
)

export default component.exports